exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-bar{margin-bottom:0}h1{height:21px}.list-container{height:100%}@media (max-width:720px){.list-container{color:#fff}.list-container .row .col-sm-9{display:none}.wizard-container .list-container h1{height:52px;line-height:1;margin-bottom:0;padding-left:70px;padding-top:10px}.wizard-container .list-container h1.detail-title{background-color:#04bafc}.aux-sidebar{display:block;position:absolute;top:10px;left:31px;font-size:150%}.table-container{padding-top:15px;min-height:45vh}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2fb5f971","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/report/SelectIndicatorWizard.vue
// module id = 837
// module chunks = 0